import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { firstValueFrom, interval, Subscription, take } from 'rxjs';
import { PatientNotification, PatientNotificationParamModel } from 'src/app/models/patient-notification';
import { ClinicPatientService } from 'src/app/services/clinic.patient.service';
import store from 'store2';
import { ToastHelper } from '../../common/toaster.helper';
import { CompanyClinicService } from 'src/app/services/companyClinic.service';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule, FormsModule, RouterModule],
	templateUrl: './header.component.html',
	styleUrl: './header.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {
	@HostBinding('class') hostClass = 'header fixed top-0 z-10 left-0 right-0 flex items-stretch shrink-0 bg-[#fefefe] dark:bg-coal-500 shadow-sm dark:border-b dark:border-b-coal-100';
	@HostBinding('attr.role') hostRole = 'banner';
	@HostBinding('attr.data-sticky') dataSticky = 'true';
	@HostBinding('attr.data-sticky-name') dataStickyName = 'header';
	@HostBinding('id') hostId = 'header';
	userName: string = "";
	userRole: string = "";
	fullName: string = "";
	listBranches: any[] = [];
	selectedBranchId: number = 0;

	constructor(private router: Router,
		private clinicPatientService: ClinicPatientService,
		private _companyClinicservice: CompanyClinicService,
		private _toastr: ToastHelper,
		private cdr: ChangeDetectorRef) { }

	private intervalSub: Subscription;
	oldLength: number = 0;
	ngOnInit(): void {
		setTimeout(() => {
			this.getClinicOfficesByCompanyy(store('companyID')).then(() => {
				this.selectedBranchId = store('userBranches');
				this.fullName = `${store("lastName")}, ${store("firstName")}`;
				this.userRole = (store("newRoleName") ?? '').toString().replace(" ", "-");
				this.userName = store("userName");
				this.cdr.markForCheck();
				this.getNotifications().then(() => {
					this.oldLength = this.notifications.length;
				});

			});

			this.intervalSub = interval(30000).subscribe(() => {
				this.getNotifications();
				if (this.notifications.length > this.oldLength && this.oldLength != 0) {
					this._toastr.showInfo(`${this.notifications.length - this.oldLength} New notification(s)!`);
				}
				this.oldLength = this.notifications.length;
				this.cdr.markForCheck();
			});
		}, 500);
	}

	ngOnDestroy(): void {
		if (this.intervalSub) {
			this.intervalSub.unsubscribe();
		}
	}

	logOut() {
		// console.log("testing out");
		store.remove("token");
		store.clear();
		this.router.navigateByUrl("/login");
	}

	notifications: PatientNotification[] = [];
	async getNotifications(): Promise<void> {
		let model = new PatientNotificationParamModel();
		model.branchID = store('totalBranches').split(',').length > 1 ? store('userBranches') : store('userBranches');
		try {
			const res: any = await firstValueFrom(
				this.clinicPatientService.GetPatientNotifications(model).pipe(take(1))
			);
			if (res != null || res != undefined) {
				this.notifications = res;
			}
			this.cdr.markForCheck();
		} catch (err) {
			console.error("Notifactions error => ", err);
		}
	}

	openNotification(patientId: number, notificationTypeId: number = 0) {
		window.open('/home/patients/profile/patient-data/' + patientId, '_blank');
	}

	openFaq() {
		window.open("./assets/faqpage/faqpage.html");
	  }

	  openVideos() {
		window.open("./assets/TutorialVideos/videos.html");
	  }

	dismissNotification(notificationId: number) {
		let model = new PatientNotificationParamModel();
		model.patientNotificationDetailID = notificationId;
		this.clinicPatientService.DismissPatientNotifications(model).pipe(take(1)).subscribe(
			{
				next: (res: any) => {
					this.getNotifications();
					this._toastr.showInfo("Dismissed!");
					//this.notifications = this.notifications.filter(function( obj ) {
					//  return obj.patientNotificationDetailID !== notificationId;
					//});
				},
				error: err => {
					this._toastr.showError("Couldn't dismiss!");
				}
			});
	}
	async getClinicOfficesByCompanyy(companyID: number): Promise<void> {
		try {
			const res: any = await firstValueFrom(
				this._companyClinicservice.GetClinicOfficesByCompany(companyID).pipe(take(1))
			);
			let clinicOfficeData = JSON.parse(res.data);
			console.log(clinicOfficeData);
			console.log(store('userBranches'));
			let clinicOfficeItems = [];
			if (clinicOfficeData.length > 0) {
				clinicOfficeData.forEach(item => {
					if (store('roleID') == 4 || (store('totalBranches').split(',')).includes(item.BranchID.toString())) {
						let clinicOfficeItem = {
							"branchID": item.BranchID,
							"branchName": item.BranchName
						}
						clinicOfficeItems.push(clinicOfficeItem);
					}
				})
			}
			this.listBranches = clinicOfficeItems;
			this.cdr.markForCheck();
		} catch (err) {
			//console.log("GetClinicOfficesByCompany error", err);
			this._toastr.showError('Load clinics Info failed!');
		}
	}

	onBranchChange(): void {
		store('userBranches', this.selectedBranchId);
		let selection = this.listBranches.find(x => x.branchID == this.selectedBranchId).branchName;
		this._toastr.showSuccess(`Clinic changed to ${selection}`!);
		window.location.reload();
	}

	trackByNotificationId(index: number, notification: any): number { return notification.patientNotificationDetailID; }
}
